import Vue from 'vue';
import Toasted from 'vue-toasted';
import Vuelidate from 'vuelidate';
import { Fragment } from 'vue-fragment';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faStop,
  faTrashAlt,
  faWindowClose,
  faSave,
  faEdit,
  faEllipsisH,
  faGasPump,
  faWallet,
  faBell,
  faChartLine,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import { createProvider } from './vue-apollo';

import Dashboard from './layouts/Dashboard.vue';
import Default from './layouts/Default.vue';

import './filters';

library.add(
  faStop,
  faTrashAlt,
  faWindowClose,
  faSave,
  faEdit,
  faEllipsisH,
  faGasPump,
  faWallet,
  faBell,
  faChartLine,
);
Vue.config.productionTip = true;

Vue.use(Vuelidate);
Vue.use(Toasted, {
  position: 'top-center',
  duration: 5000,
  keepOnHover: true,
});

Vue.component('default-layout', Default);
Vue.component('dashboard-layout', Dashboard);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('fragment', Fragment);

new Vue({
  router,
  apolloProvider: createProvider(),
  render: h => h(App),
}).$mount('#app');
